import { cn } from 'shadcn/lib/utils';

/**
 * Displays a value or "None" if the value is falsy.
 *
 * @param {string} value - The value to display.
 */
export function displayOrNone(value) {
    return value || <span className="italic text-muted-foreground">None</span>;
}

/**
 * Displays a labeled row in a grid-based summary layout.
 *
 * @param {React.ReactNode} children - The value to display.
 * @param {string} label - The label to display.
 * @param {string} labelClass - Additional class name for the label.
 * @param {string} valueClass - Additional class name for the value container.
 */
export function Row({ children, label, labelClass = '', valueClass = '' }) {
    return (
        <>
            <p className={cn('text-xs font-medium text-muted-foreground', labelClass)}>{label}</p>
            <div className={valueClass}>{children}</div>
        </>
    );
}

/**
 * Displays a color swatch with its hex value.
 *
 * @param {string} color - The color to display.
 */
export function ColorSwatch({ color }) {
    return (
        <div className="flex items-center gap-2">
            <div className="size-4 rounded border" style={{ backgroundColor: color || '#FFFFFF' }} />
            <p className="text-sm text-left">{displayOrNone(color)}</p>
        </div>
    );
}
